__gh__webApp.paywall.pianoVX = {

	"loginSuccessCounter": 0,
	"experienceCounter": 0,
	"firstExperienceLoaded": false,
	"refreshExperienceCallbacks": [],

	"init": function(){
	
		if (this.isDisabled()) {return;}
		
		__gh__webApp.paywall.loginSuccessCounter = 0;
		 
		this.updateLoginLogoutText();
		this.bindEvents();
	},
	
	
	/**
	 * Call a piano experience callback function and ensure that it runs whether Piano has loaded yet or not
	 * Callbacks will run when piano first loads or if loaded it will refresh the experience to run the callbacks
	 * Piano specific, so I'd recommend keeping the call to this within __gh__webApp.paywall.pianoVX object
	 * @param {object} callbackObject - callback object run by __gh__webApp.common.callFunction
	 * @param {object} [articleObject=null] - will run refresh article experience if present
	 * @example
	 *	__gh__webApp.paywall.callExperienceFunction({
	 *		"callbackObject": {
	 *			"callback": function(){
	 *				alert("hey-o!");
	 *			}
	 *		}
	 *	});
	
	 */
	"callExperienceFunction": function(options){
		var paywallData 			= __gh__webApp.paywall.getData(),
			paywall					= __gh__webApp.paywall,
			callbackObject 			= options.callbackObject,
			articleObject			= ("articleObject" in options) ? options.articleObject : null,
			disableRefreshExperience= ("disableRefreshExperience" in options) ? options.disableRefreshExperience : false,
			firstExperienceLoaded 	= __gh__webApp.paywall.firstExperienceLoaded;
		
		__gh__webApp.paywall.refreshExperienceCallbacks.push(callbackObject);
		
		if (!paywallData || !firstExperienceLoaded) {return;}
		
		if (disableRefreshExperience){
			paywall.runRefreshExperienceCallbacks();
			return;
		}
		
		if (articleObject){
			paywall.refreshArticleExperience(articleObject);
			return;
		}
		paywall.refreshExperience();
		
	},
	
	
	"bindEvents":function(){
		var thisObject = __gh__webApp.paywall;
		
		//Login event
		$(document).on('click.paywall-login','[data-gh-paywall-event=login]',function(event){
			event.preventDefault();
			var eventObject 	= $(this).data("gh-paywall-event-object"),
				callbackObject	= (eventObject && "callbackObject" in eventObject) ? eventObject.callbackObject : null;
			
			thisObject.showUserLoginForm(callbackObject);
		});
		
		//Logout event
		$(document).on('click','[data-gh-paywall-event=logout]',function(event){
			event.preventDefault();
			thisObject.logout();
		});
		
		$(document).on('click','[data-gh-paywall-show-offer-object]',function(event){
			event.preventDefault();
			var showOfferObject = $(this).data("gh-paywall-show-offer-object");
			thisObject.showOffer(showOfferObject);
		});
	},
	
	
	"getData": function(articleID) {		
		return JSON.parse(__gh__webApp.localStorage.getItem("_vxData"));
	},
	
	
	"isDisabled": function(){
		var commonJS = __gh__webApp.common;
		return (__gh__coreData["3rdPartyData"].paywall.pianoVX.disabled || !commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"paywall.pianoVX.aid"));
	},
	
	
	"isUserLoggedIn": function(){
		if (this.isDisabled()) {return false;}
		var commonJS 	= __gh__webApp.common,
			userCookie;
		if(userCookie = commonJS.getCookie("__ut")){
			return userCookie;
		}
		return false;
	},
	
	
	"showUserLoginForm": function(callbackObject){
		if (this.isDisabled()) {return false;}
		
		var commonJS	= __gh__webApp.common,
			thisObject 	= __gh__webApp.paywall;
		tp.push(["init", function() {
			tp.user.showLogin({  
				loginSuccess:function() {
					//Make sure it only runs once
					__gh__webApp.paywall.loginSuccessCounter++;
					if (__gh__webApp.paywall.loginSuccessCounter > 1) {return;}
					
					thisObject.updateLoginLogoutText();
					thisObject.refreshExperience();
					
					if (callbackObject){
						commonJS.callFunction(callbackObject);
					}
					
				} 
			});
		}]);
	},
	
	"showOffer": function(options){
		if (this.isDisabled()) {return false;}
		
		var commonJS = __gh__webApp.common,
			offer = {
				"displayMode"	: (options.displayMode) ? options.displayMode : "modal",
				"templateId"	: (options.templateId) ? options.templateId : null,
				"offerId"		: (options.offerId) ? options.offerId : null
			};
		
		//Remove null or undefined items
		offer = commonJS.cleanObject(offer);
		
		tp.push(["init", function() {
		    tp.offer.show(offer);
		}]);
	},
	
	"updateLoginLogoutText": function(){
		if (this.isDisabled()) {return false;}
		
		var thisObject 	= __gh__webApp.paywall,
			$loginLink	= $("#toprail-login").find("a");
		
		//Log out text
		if (thisObject.isUserLoggedIn()) {
			$loginLink.find("span").html("log out");
			$("[data-gh-paywall-event]").attr("data-gh-paywall-event","logout");
			return;
		}
	
		//Log in text
		$loginLink.find("span").html("log in");
		$("[data-gh-paywall-event]").attr("data-gh-paywall-event","login");
		
	},
	
	
	"logout":function(){
		if (this.isDisabled()) {return false;}
		
		var thisObject = __gh__webApp.paywall;
		tp.push(["init", function() {
			tp.user.logout(function(){
				thisObject.updateLoginLogoutText();
				__gh__webApp.paywall.loginSuccessCounter = 0;
				__gh__webApp.localStorage.removeItem('_vxData');//remove stored Piano VX user data
			});
		}]);
	},
	
	"meterReadMoreArticle": function(articleDOM,articleObject) {
		__gh__webApp.paywall.refreshArticleExperience(articleObject);
	},
	
	
	"userLogin":function(callback){
		var callback = callback || null;
		this.showUserLoginForm(callback);
	},
	
	"runRefreshExperienceCallbacks":function(){
		var paywall 	= __gh__webApp.paywall,
			callbacks	= paywall.refreshExperienceCallbacks;
	
		if (!callbacks.length) {return;}
		// Run any experience callbacks
		callbacks.push({"callback":function(){
			__gh__webApp.paywall.refreshExperienceCallbacks = [];
		}});
		__gh__webApp.common.callArrayOfFunctions(callbacks);
	},
	
	"refreshExperience": function(options){
	
		if (this.isDisabled()) {return;}
		var options = (options) ? options : {},
			tags 	= ("tags" in options) ? options.tags : [];
		
		// Set Tags
		tp.push(["setTags", tags]);
		
		// Execute Experience
		tp.experience.execute();
	},
	
	
	"refreshArticleExperience": function(articleObject){
		var thisObject	= __gh__webApp.paywall;
		if (thisObject.isDisabled()) {return;}
		
		var commonJS 	= __gh__webApp.common,
			freemium 	= commonJS.getObjectProperty(__gh__coreData["3rdPartyData"],"paywall.pianoVX.freemium"),
			isMetered 	= articleObject.metered,
			tags		= ((freemium && isMetered) || !freemium)  ? ["metered"] : [];
	
		thisObject.refreshExperience({
			"tags": tags
		});
		
	},
	
	
	"vxStorage": function(data){
		var commonJS	= __gh__webApp.common,
			_vxData 	= {
				"email"		: data.user.email,
				"id"		: data.user.uid,
				"access"	: data.accessList.length,
				"name"		: data.user.firstName+" "+data.user.lastName,
				"firstName"	: data.user.firstName,
				"lastName"	: data.user.lastName,
				"showPaywall": false
			},
			localStorage = __gh__webApp.localStorage;
			
		//Event data
		for (var i in data.result.events){
			var event 			 = data.result.events[i],
				showPaywallCheck = ["showOffer","showTemplate"]
			
			//Hit Paywall
			if (commonJS.inArray(event.eventType,showPaywallCheck)){
				_vxData.showPaywall = true;
			}
		}
		
		
		if(localStorage.getItem("_vxData")){
			localStorage.removeItem("_vxData");
		}
	
		localStorage.setItem("_vxData",JSON.stringify(_vxData));
		
	},
	"offerCallback":function(options){
		var commonJS					= __gh__webApp.common,
			showOfferCallbackObject 	= (options.showOfferCallbackObject) ? options.showOfferCallbackObject : null,
			noOfferCallbackObject	 	= (options.noOfferCallbackObject) ? options.noOfferCallbackObject : null,
			isDisabledCallbackObject 	= (options.isDisabledCallbackObject) ? options.isDisabledCallbackObject : null,
			articleObject				= (options.articleObject) ? options.articleObject : null;
			
		if (this.isDisabled()) {
			return (isDisabledCallbackObject) ? commonJS.callFunction(isDisabledCallbackObject) : false;
		}
		
		var callExperienceOptions = {
			"disableRefreshExperience":true,
			"callbackObject": {
				"callback": function(){
					var paywallData = __gh__webApp.paywall.getData();
					
					if (!paywallData.showPaywall && noOfferCallbackObject) {
						commonJS.callFunction(noOfferCallbackObject);
						return; 
					}
					
					
					if (showOfferCallbackObject){
						commonJS.callFunction(showOfferCallbackObject);
					}
				}
			}
		};
		
		if (articleObject){
			options.articleObject = articleObject;
		}
		
		__gh__webApp.paywall.callExperienceFunction(callExperienceOptions);

	},
	/**
	 * Library is loaded server side
	 */
	"loadLibrary": function() {},

	"meterMainArticle": function(articleDOM,articleObject) {},
	"readSession": function(){},
	"sessionBar":{"incrementTotalPremiumClicks":function(){}},
};
